import File from "../models/FileObject";

export default {
  methods: {
    findFileObject: function (file) {
      return this.files.find(f => file === f._file)
    },

    filesInclude: function (file) {
      let ff = this.findFileObject(file);
      return ff instanceof File
    }
  }
}